@if (externArbetsorderDetails) {
  <rask-page
    pageTitle="Externarbetsorder detaljer"
    noPadding
    [footerShow]="true">
    <ng-container headerContent>
      <div class="row">
        <rask-input class="col-1" label="Virkesorder" [ngModel]="externArbetsorderDetails.avtalsobjekt" [readonly]="true"></rask-input>
        <rask-input class="col-2" label="Namn" [ngModel]="externArbetsorderDetails.arbetsorderNamn" [readonly]="true"></rask-input>
        <rask-input class="col-3" label="Uppdragsgivare" [class.input-italic]="!externArbetsorderDetails.ckLeverantorKod" [ngModel]="externArbetsorderDetails.uppdragsgivare" [readonly]="true"></rask-input>
        <rask-input class="col-2" label="Kontraktsansvarig" [ngModel]="externArbetsorderDetails.kontraktsansvarig" [readonly]="true"></rask-input>
        <rask-selector
          class="col-2"
          label="Transportforetag"
          [viewFormatter]="formatter"
          [formatter]="outputFormatter"
          (ngModelChange)="transportforetagChanged($event)"
          [(ngModel)]="externArbetsorderDetails.transportforetagId"
          [values]="transportforetagList">
        </rask-selector>
        <div class="col-2 header-status-icon">
          <rask-label size="12">Status</rask-label>
          <rask-icon [text]="externArbetsorderDetails.felmeddelande" [icon]="getIcon(externArbetsorderDetails)"></rask-icon>
        </div>
      </div>
    </ng-container>
    <div class="row">
      <rask-list class="footer-padding" [data]="getListData()" [virtualScroll]="true" virtualScrollType="window" [virtualScrollItemHeight]="36" [fixedHeader]="true">
        <rask-list-column header="Radnummer" field="radnummer" width="5%" [sortable]="true"></rask-list-column>
        <rask-list-column header="SSTE" field="sste" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Mottagningsplats" field="mottagningsplats" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="MMA" field="mma" width="5%" [sortable]="true"></rask-list-column>
        <rask-list-column header="MMB" field="mmb" width="5%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Kokllektiv" field="kollektiv" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="MMC" field="mmc" width="5%" [sortable]="true"></rask-list-column>
        <rask-list-column header="MMD" field="mmd" width="5%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Handelssortiment" field="handelssortiment" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Ignorera" width="5%">
          <ng-template let-row="row">
            <rask-checkbox class="row-checkbox" [(ngModel)]="row.checked" [disabled]="disableIgnorera(row)" (checkedChange)="toggleStatus($event, row)"></rask-checkbox>
          </ng-template>
        </rask-list-column>
        <rask-list-column width="15%">
          <ng-template let-row="row">
            <rask-icon [text]="row.felmeddelande" [icon]="getIconRow(row)"></rask-icon>
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Vo status" field="voStatusRad" width="10%" [sortable]="true"></rask-list-column>
      </rask-list>
    </div>
  </rask-page>
}
